import { useTipSuccessModal } from 'hooks/useTipSuccessModal';
import TipSuccessModal from 'components/TipSuccessModal/TipSuccessModal';

const TipSuccessModalHandler: React.FC = () => {
  const {
    isOpen,
    tipData,
    closeTipSuccessModal,
    loading,
  } = useTipSuccessModal();

  if (!isOpen || !tipData || loading) {
    return null;
  }

  return (
    <TipSuccessModal
      isOpen={isOpen}
      onClose={closeTipSuccessModal}
      tipData={tipData}
      store={tipData.store}
    />
  );
};

export default TipSuccessModalHandler;
